import React, { FunctionComponent } from 'react'
import { Navigate, Route, Routes } from 'react-router'

import { AdditionalProfileManagementConfig } from '../../../state/configuration'
import {
  RenewalAdditionalProfileCreatePage,
  RenewalAdditionalProfilePage,
} from './RenewalAdditionalProfilePage'

export enum AdditionalProfilePath {
  Profile = 'profile/:profileCode',
  NewProfile = 'profile',
}

export interface RenewalAdditionalProfilePageProps {
  config: AdditionalProfileManagementConfig
}

export const RenewalAdditionalProfileRouter: FunctionComponent<
  RenewalAdditionalProfilePageProps
> = ({ config }) => (
  <Routes>
    <Route
      path={AdditionalProfilePath.Profile}
      element={<RenewalAdditionalProfilePage config={config} />}
    />
    <Route
      path={AdditionalProfilePath.NewProfile}
      element={<RenewalAdditionalProfileCreatePage config={config} />}
    />
    <Route path='*' element={<Navigate to='..' />} />
  </Routes>
)
